import domain from "./DomainService";

/**
 * The browser's IANA timezone (e.g. "America/New_York"). Sent alongside every auto-comment call
 * so the backend can capture/refresh it - kynzo-server has no other reliable way to know a user's
 * timezone independent of a live browser request, and needs it to convert "9am" (as the user
 * means it, in their own time) into the correct UTC hour for the active-window scheduling.
 */
function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

/** Fetches the current user's auto-comment settings (enabled, daily cap, active window, cooldown). */
export function GetAutoCommentSettingsService() {
  const token = localStorage.getItem("token");
  const tz = browserTimezone();
  const query = tz ? `?timezone=${encodeURIComponent(tz)}` : "";
  return fetch(domain() + "auto-comment/settings" + query, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
  });
}

/**
 * What Agent Mode will comment on next and roughly when, plus posts it's skipping and why.
 * Resolves to { status, next_at, today_count, daily_cap, dry_run, queue: [...], skipped: [...] } -
 * only the first queue item's time is firm, later items are meant to be shown as a day.
 */
export function GetAutoCommentQueueService() {
  const token = localStorage.getItem("token");
  const tz = browserTimezone();
  const query = tz ? `?timezone=${encodeURIComponent(tz)}` : "";
  return fetch(domain() + "auto-comment/queue" + query, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
  });
}

/** Directly toggles auto-comment on/off, with no AI involved. */
export function ToggleAutoCommentService(enabled) {
  const token = localStorage.getItem("token");
  return fetch(domain() + "auto-comment/settings", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
    body: JSON.stringify({ enabled, timezone: browserTimezone() }),
  });
}

/**
 * Sends a free-text rule prompt (e.g. "auto comment 80 contacts per day for 8 hours every day,
 * never comment the same person more than once a week") to be parsed into concrete settings.
 * Resolves to { applied: [{setting, old_value, new_value}], message, settings }.
 */
export function ApplyAutoCommentRulesService(prompt) {
  const token = localStorage.getItem("token");
  return fetch(domain() + "auto-comment/apply-rules", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: "JWT " + token,
    },
    body: JSON.stringify({ prompt, timezone: browserTimezone() }),
  });
}
